import { bscTestnet, bsc } from '@reown/appkit/networks'
import { AppKitNetwork } from '@reown/appkit/networks'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { createAppKit } from "@reown/appkit/react";

// Get projectId from https://dashboard.reown.com
export const projectId = 'a829b7491c7fe212d8ef6c98f4eeb5be' // this is a public projectId only to use on localhost

if (!projectId) {
  throw new Error('Project ID is not defined')
}

// Create a metadata object - optional
export const metadata = {
  name: 'Nexatrade',
  description: 'Nexatrade Dapp',
  url: window.location.origin,
  // url: 'http'
  // 'https://nexatrade.uk/',
  icons: [
    'https://nexatrade.nyc3.cdn.digitaloceanspaces.com/tlaEmeeiTlspma/logo.png'
  ],
}

// for custom networks visit -> https://docs.reown.com/appkit/react/core/custom-networks
// export const networks = [bscTestnet]
export const networks = [bsc]


// Set up Solana Adapter
export const ethersAdapter = new EthersAdapter();

//  INIT APPKIT
export const appKit = createAppKit({
  adapters: [ethersAdapter],
  networks,
  projectId,
  metadata,
  themeMode: "dark",
  features: {
    socials: false,
    email: false,
    walletSearch: false,
    // allWallets: false,
  },
  featuredWalletIds: [
    'metamask',
    'trust',
    'walletconnect'
  ],
  enableExplorer: false,
  debug: true,
  enableMobileFullScreen: true,

});














// import {bscTestnet} from '@reown/appkit/networks'
// import  { AppKitNetwork } from '@reown/appkit/networks'
// import { EthersAdapter } from '@reown/appkit-adapter-ethers'

// // Get projectId from https://dashboard.reown.com
// export const projectId = 'a829b7491c7fe212d8ef6c98f4eeb5be' // this is a public projectId only to use on localhost

// if (!projectId) {
//   throw new Error('Project ID is not defined')
// }

// // Create a metadata object - optional
// export const metadata = {
//   name: 'Nexatrade',
//   description: 'Nexatrade Dapp',
//   url:window.location.origin,
//   // url: 'http'
//   // 'https://nexatrade.uk/',
//   icons: [
//     'https://nexatrade.nyc3.cdn.digitaloceanspaces.com/tlaEmeeiTlspma/logo.png'
//   ],
// }

// // for custom networks visit -> https://docs.reown.com/appkit/react/core/custom-networks
// export const networks = [bscTestnet]

// // Set up Solana Adapter
// export const ethersAdapter = new EthersAdapter();










// // src/config/appkit.js
// import { createAppKit } from "@reown/appkit/react";
// import { EthersAdapter  } from "@reown/appkit-adapter-ethers";
// import { mainnet, sepolia } from "@reown/appkit/networks";

// export const networks = [
//   mainnet,
//   sepolia,
//   {
//     id: 56, // ✅ BSC Mainnet
//     name: "BNB Smart Chain",
//     nativeCurrency: {
//       name: "BNB",
//       symbol: "BNB",
//       decimals: 18,
//     },
//     rpcUrls: {
//       default: {
//         http: ["https://bsc-dataseed.binance.org"],
//       },
//     },
//     blockExplorers: {
//       default: { name: "BscScan", url: "https://bscscan.com" },
//     },
//   },
// ];

// export const metadata = {
//   name: "NexaTrade",
//   description: "NexaTrade Web3 App",
//   url: window.location.origin, // must be added in Reown allowed origins
//   icons: ["https://avatars.githubusercontent.com/u/179229932"],
// };

// export const projectId = "a829b7491c7fe212d8ef6c98f4eeb5be";

// createAppKit({
//   adapters: [new EthersAdapter()],
//   networks,
//   projectId,
//   metadata,
//   themeMode: "dark",
//   features: {
//     socials: false,
//     email: false,
//     walletSearch: true,
//   },
// });


// export const ethersAdapter = new EthersAdapter()